import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';

import { queryClient } from '../../configs/queryClient';
import useServiceRecordQuery from '../useServiceRecordQuery';

async function update(axios: AxiosInstance, serviceRecordId: number, dataForEndpoint: any): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/service-record/${serviceRecordId}`, dataForEndpoint);
  return data;
}

export default function useUpdateServiceRecordRequestStatus(serviceRecordId: number) {
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationFn: (dataForEndpoint: any) => update(axios, serviceRecordId, dataForEndpoint),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: useServiceRecordQuery.getKey(serviceRecordId) });
    },
    onError: (error: any) => {
      manageErrorResponse(toast, error.response);
    },
  });
}
